module.exports = __webpack_public_path__ + "img/G-basic.b180292a.svg";